import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { BASE_URL } from '../config';

export default class SearchResults extends PureComponent {
  render() {
    if (!this.props.matchingComponents.length) {
      return (
        <p>Nothing found, keep on searching!</p>
      )
    }

    return (
      <ul
        style={{
          listStyleType: 'none',
          margin: '16px 0',
          padding: 0,
        }}
      >
        {
          this.props.matchingComponents.map(component => (
            <li key={component.name} style={{ padding: 8 }}>
              <Link
                to={`${BASE_URL}/${component.name}/latest/index.html`}
                onClick={this.props.onResultClicked}
              >
                {component.name}
              </Link>
              <span style={{ display: 'block' }}>{component.description}</span>
            </li>
          ))
        }
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchResults.jsx